import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconUndoSvg } from "./IconUndoSvg.mjs";
const IconUndo = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconUndoSvg, ...svgProps }) });
export {
  IconUndo
};
